import React from "react";

import Button from "component/button/Button";
import ConfirmAlert from "component/alert/ConfirmAlert";
import ConfirmAlertCard from "component/section/ConfirmAlertCard";
import FullScreenLoading from "component/section/FullScreenLoading";

import { colors, strings } from "asset/constant";
import { useLogout } from "client/api";
import { useFlag } from "hook";
import { css } from "style";
import { mq } from "utils";

export default function Logout(props: {
  renderButton?: (logout: () => void) => JSX.Element;
}) {
  const { renderButton } = props;

  const { flg: modal, on: showModal, off: hideModal } = useFlag();

  const logoutMut = useLogout();

  const _onLogoutConfirm = () => logoutMut.mutate();

  const _goToLogout = () => {
    showModal();
  };

  return (
    <>
      {renderButton ? (
        renderButton(_goToLogout)
      ) : (
        <Button
          onPress={_goToLogout}
          title={{
            value: strings.logout,
            color: colors.text.normal,
            size: "md",
          }}
          icon={{ name: "poweroff", size: mq(12), color: colors.danger }}
          width={mq(70)}
          contentSeparator={mq(10)}
          bgColor={colors.transparent}
          style={{ ...css.selfEnd, marginVertical: mq(5) }}
        />
      )}

      <ConfirmAlert
        force
        show={modal}
        hide={hideModal}
        renderContent={(close) => (
          <ConfirmAlertCard
            icon={{ name: "logout" }}
            title={strings.logout}
            message={strings.are_you_sure_to_logout}
            noTitle={strings.cancel}
            onNoPress={close}
            yesTitle={strings.logout_from_account}
            onYesPress={() => {
              close();
              _onLogoutConfirm();
            }}
          />
        )}
      />

      {logoutMut.isLoading && <FullScreenLoading />}
    </>
  );
}
